/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AddDashboardWidgetRequestBody = {
  /**
   * The dashboard to place it on
   */
  id: string;
  /**
   * The widget to place
   */
  widgetId: string;
};

/** @internal */
export type AddDashboardWidgetRequestBody$Outbound = {
  id: string;
  widget_id: string;
};

/** @internal */
export const AddDashboardWidgetRequestBody$outboundSchema: z.ZodMiniType<
  AddDashboardWidgetRequestBody$Outbound,
  AddDashboardWidgetRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    widgetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      widgetId: "widget_id",
    });
  }),
);

export function addDashboardWidgetRequestBodyToJSON(
  addDashboardWidgetRequestBody: AddDashboardWidgetRequestBody,
): string {
  return JSON.stringify(
    AddDashboardWidgetRequestBody$outboundSchema.parse(
      addDashboardWidgetRequestBody,
    ),
  );
}
